import React, { Component } from 'react'
import PromotionPeriodComponent from './period'
import { connect } from 'react-redux'
import { api } from "../../../../api/index"

class PromotionsPeriodsComponent extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="grid-x grid-margin-x grid-margin-y">
				<div className="cell text-right">
					<button type="submit" onClick={api.promotions.addPeriod} className="button secondary">Nieuwe periode</button>
				</div>
				<div className="cell" id="PromotionPeriods">
					{
						this.props.promotion.periods.sort( ( a, b ) => {
							return b.startDateTimeStamp - a.startDateTimeStamp;
						}).map((period, key ) => {
							return (
								<PromotionPeriodComponent addVariant={this.props.addVariant} key={key} periodKey={key} period={period} />
							);
						})
					}
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state ) => {
	return {
		promotion: state.promotion
	};
};

export default connect(mapStateToProps)(PromotionsPeriodsComponent);


// WEBPACK FOOTER //
// ./src/application/components/promotions/parts/periods.js